<template>
  <!-- <DefaultLayout> -->
    <RouterView :key="(route.params.lang as string) || 'ru'" />
  <!-- </DefaultLayout> -->
</template>

<script setup lang="ts">
import { onMounted } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { useAuthStore } from './stores/auth'

const route = useRoute()
const authStore = useAuthStore()
// Попытка обновить токен при монтировании
onMounted(() => {
  authStore.fetchUser()
})

authStore.loadPendingUserFromStorage()

</script>

<style scoped>
/* Добавь свои стили тут */
</style>
